import { isEmpty } from 'remeda'
import type { Category } from '@velasca/hooks/use-category-store'
import type {
  ApparelProductProps,
  AttributeForFacetingConfig,
  MenuItem,
  Variant,
} from '@velasca/types'
import { getProductCardImage } from '@velasca/utils/get-product-card-image'
import { isSeason } from '@velasca/utils/is-season'
import type { FormattedVariantProps } from './types'

// TODO: controllare che tutte le logiche di formatApparelData o groupByProduct siano riportate anche qui
const getFormattedVariant = ({
  handle,
  price,
  compare_at_price,
  images,
  color_short,
  material_short,
  texture_image_name,
  variant_color_style,
  pattern_image_name,
  sole_color_hex,
  variant_colors,
  reviews_count,
  reviews_average,
  is_new,
  staff_pick_icon_id,
  season_id,
  season_name,
  collection_brand_id,
  collection_brand_name,
  product_type,
  objectID,
  color,
  material,
  jolly,
}: FormattedVariantProps): Variant => {
  const validSeasonID = season_id && isSeason(season_id) ? season_id : undefined

  return {
    handle,
    id: objectID,
    price,
    compareAtPrice: compare_at_price,
    description: {
      bold: color_short || color,
      thin: material_short || material,
    },
    img: getProductCardImage({
      images,
      customProductType: product_type,
    }),
    reviews: {
      count: reviews_count,
      average: reviews_average,
    },
    variantDot: {
      colors: variant_colors ? JSON.parse(variant_colors) : [],
      sole: sole_color_hex ?? null,
      pattern: variant_color_style ?? null,
      texture: texture_image_name ?? null,
      img: pattern_image_name ?? null,
    },
    staffPickIconID: staff_pick_icon_id ?? null,
    isNew: is_new ?? false,
    collectionBrandName: collection_brand_name,
    collectionBrandID: collection_brand_id,
    seasonID: validSeasonID,
    seasonName: season_name,
    jolly,
  }
}

export const formatAlgoliaHit = (
  hit: FormattedVariantProps,
): ApparelProductProps => {
  return {
    title: hit.title,
    productType: hit.custom_type,
    collectionBrandID: hit.collection_brand_id,
    variants: [getFormattedVariant(hit)],
  }
}

export const getFilteredCategories = (
  category: { isRefined: boolean; value: string }[],
  currentCategory: { name: string; children?: { handle: string }[] },
) => {
  const currentCategoryChildrenHandle = currentCategory.children?.map(
    (item) => item.handle,
  )

  return category.filter((item) => {
    return (
      item.value !== currentCategory.name &&
      currentCategoryChildrenHandle?.includes(item.value)
    )
  })
}

export const getDuplicateTitles = (items: MenuItem[] | undefined): string[] => {
  if (!items || isEmpty(items)) {
    return []
  }

  const seenTitles = new Set<string>()
  const duplicates = new Set<string>()

  for (const item of items) {
    const { title } = item

    if (seenTitles.has(title)) {
      duplicates.add(title)
    } else {
      seenTitles.add(title)
    }
  }

  return [...duplicates]
}

export const buildPanelsToShow = (
  panels: AttributeForFacetingConfig[],
  currentCategory: Category,
): AttributeForFacetingConfig[] => {
  const result = panels
    .filter((panel) => {
      if (!currentCategory?.hasShoes) {
        return panel.handle !== 'sole'
      }

      return true
    })
    .filter((panel) => {
      if (!currentCategory?.isContainerCategory) {
        return panel.handle !== 'categories'
      }

      return true
    })
    .filter((panel) => {
      // we are doing this because of https://velasca.atlassian.net/browse/VAMS-249?focusedCommentId=18666
      const isMacroCollection =
        !currentCategory?.isMainCollection && !currentCategory?.isSubCollection

      // If the panel is 'categories', show it only if it's a macro collection.
      // Otherwise (for any other panel), let it pass this specific filter.
      if (panel.handle === 'categories') {
        return isMacroCollection
      }

      return true
    })

  return result
}
